module.exports = __webpack_public_path__ + "img/rubin_benefit_04_bike.05d042cd.svg";